import safeFetch from "./utils/safeFetch"

// Exponer el fetch nativo para debugging
if (typeof window !== "undefined") window.__nativeFetch = safeFetch

import { installMediaPipeSilencer } from "./utils/silenceMediaPipe"
import "./index.css"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.jsx"
import { ToastProvider } from "./components/Toast.jsx"
import { NotificationProvider } from "./notifications/NotificationContext.jsx"

// Instalar filtro de logs MediaPipe ANTES de renderizar
installMediaPipeSilencer()

// StrictMode SOLO en dev: en produccion duplica renders y useEffects
// (causa polling doble, warnings raros, y consumo extra de CPU)
const AppTree = (
  <ToastProvider>
    <NotificationProvider>
      <App />
    </NotificationProvider>
  </ToastProvider>
)

ReactDOM.createRoot(document.getElementById("root")).render(
  import.meta.env.DEV ? <React.StrictMode>{AppTree}</React.StrictMode> : AppTree
)
